@if (scripts) {
  <div [innerHtml]="scripts" runScripts="before"></div>
}
@if (html) {
  <div [innerHtml]="html"></div>
}
@if (scripts) {
  <div [innerHTML]="scripts" runScripts="after"></div>
}
